(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("transparent-background", [], factory);
	else if(typeof exports === 'object')
		exports["transparent-background"] = factory();
	else
		root["transparent-background"] = factory();
})(self, function() {
return 